import UICardGrid from 'UIComponents/card/UICardGrid';
import { InfoCard } from './InfoCard';
import Section from './Section';
import { SectionHeader } from './SectionHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const InfoCardsSection = ({
  background,
  headerIcon,
  header,
  cards
}) => {
  return /*#__PURE__*/_jsxs(Section, {
    background: background,
    children: [/*#__PURE__*/_jsx(SectionHeader, {
      iconName: headerIcon,
      header: header
    }), /*#__PURE__*/_jsx(UICardGrid, {
      columnSize: "300px",
      className: "p-top-12",
      children: cards.map((card, i) => /*#__PURE__*/_jsx(InfoCard, Object.assign({}, card), `${card.link.url}-${i}`))
    })]
  });
};